import { User } from "../../../../user/types";
import { DbtDocsShareDetails } from "../../types";

export interface Conversation {
  timestamp: string;
  user_id: number;
  message: string;
  conversation_id: number;
}

export interface ConversationGroup {
  owner: number;
  conversation_group_id: number;
  conversations: Conversation[];
  status: "Pending" | "Expired";
  meta: {
    field?: "description";
    column?: string;
    filePath: string;
    highlight: string;
    uniqueId?: string;
    resource_type?: string;
    range: {
      end: { line: number; character: number };
      start: { line: number; character: number };
    };
  };
}

export enum ConversationSources {
  DBT_DOCS = "dbt-docs",
  DOCUMENTATION_EDITOR = "documentation-editor",
  SAAS = "saas",
}

export interface ConversationGroupStateProps {
  currentUserId: User["id"] | undefined;
  conversationGroup: ConversationGroup;
  shareId: DbtDocsShareDetails["share_id"];
  isSelected: boolean;
}
